import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { getMedicalPartnerApi } from "@/utils/apis/doctor/report";

import { RootState } from "@/store/store";

export const fetchMedicalPartnerReport = createAsyncThunk(
  "medicalPartnerReport/fetch",
  async () => {
    const response = await getMedicalPartnerApi();
    return response;
  }
);

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const medicalPartnerReportSlice = createSlice({
  name: "medicalPartnerReport",
  initialState,
  reducers: {
    resetReport: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedicalPartnerReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMedicalPartnerReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchMedicalPartnerReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch report";
      });
  },
});

const selectMedicalPartnerReport = (state: RootState) => state.medicalPartner;

export const medicalPartnerReportSelector = createSelector(
  [selectMedicalPartnerReport],
  (medicalPartnerReport) => ({
    data: medicalPartnerReport.data,
    status: medicalPartnerReport.status,
    error: medicalPartnerReport.error,
  })
);

export const { resetReport } = medicalPartnerReportSlice.actions;

export default medicalPartnerReportSlice.reducer;
